export const SET_PROGRESS_COUNTER = 'SET_PROGRESS_COUNTER';
export const SET_CURRENT_STAGE = 'SET_CURRENT_STAGE';
export const STORE_VALUES = 'STORE_VALUES';
export const DISABLE_REDIRECTING_TO_FIRST_PAGE = 'DISABLE_REDIRECTING_TO_FIRST_PAGE';
export const CLEAR_STAGES = 'CLEAR_STAGES';
export const RESET_STAGE_PROGRESS = 'RESET_STAGE_PROGRESS';
export const RESET_FORM = 'RESET_FORM';
export const SET_ORIGINAL_INQUIRY_DATA = 'SET_ORIGINAL_INQUIRY_DATA';
export const SAVE_CREATED_INQUIRY_ID = 'SAVE_CREATED_INQUIRY_ID';
